import React, { Component } from 'react'

import Autocomplete from '../../src/Autocomplete';
import Technics from "../Technics/Technics";
import { connect } from 'react-redux';
import { modalAction } from "../../actions/index";
import { addTicket } from '../../actions/addNewTicket'
import { fetchDataDepartament, departamentClear } from "../../actions/departament"
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import './newticket.css'


import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import { itemsFetchData, ticketsUrl } from "../../actions";
import { listModelListNewTicket, clearModelListNewTicket } from "../../actions/modelList"

import { URL_API } from "../../constants";

const styles = theme => ({
  appBar: {
    position: 'relative',
    background: '#0288d1',
  },
  flex: {
    flex: 1,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',

  },
  formControl: {
    marginTop: theme.spacing.unit,
    minWidth: 220,
  },
  root: {
    padding: '2rem',
    boxSizing: 'border-box'
  },

  input: {
    //margin: theme.spacing.unit,
    maxWidth: '100%'
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class NewTicket extends Component {

  state = {
    series: '',
    model: [],
    model_list: [],
    dep: '',
    description: '',
    techlist: '',
    isValid: true
  };



  handleClose = () => {
    this.props.closeModal(false);
    this.setState({
      serial: '',
      techlist: '',
      model: [],
      series: '',
      dep: '',
      description: ''
    })
    this.props.departamentClear();
    this.props.clearModelListNewTicket();
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
    if (name === 'techlist') {
      this.fetchModelList(event.target.value)
      this.setState({
        model: []
      })
      if (event.target.value === '') {
        this.setState({
          model: []
        })
      }
    }
    setTimeout(() => {
      this.handelValidate()
    }, 100)
  }

  handleChangeDep = (id) => {
    this.setState({ dep: id })
    setTimeout(() => {
      this.handelValidate()
    }, 100)

  }

  handleSubmit = ev => {
    ev.preventDefault()
    // this.props.addComment(this.state)
    const { series, model, dep, description } = this.state;
    const jData = {
      user: this.props.user_id,
      status: 1,
      series,
      model,
      dep,
      description
    };

    this.props.actionTicket(jData);
    this.handleClose();
    setTimeout(() => {
      this.props.fetchData(`${URL_API}/request/?status=`);
    }, 1000)
    this.setState({
      serial: '',
      model: '',
      series: '',
      dep: '',
      description: '',
      isValid: true
    })
  }

  fetchModelList = (id) => {
    this.props.listModelListNewTicket(id);
  }

  handelValidate() {
    const { series, model, dep, description } = this.state;
    if (series !== '' && model !== '' && dep !== '' && description !== '') {
      this.setState({ isValid: false })
    } else {
      this.setState({ isValid: true })
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        fullScreen
        TransitionComponent={Transition}>
        <form onSubmit={this.handleSubmit}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <Icon>close</Icon>
              </IconButton>
              <Typography color="inherit" className={classes.flex}>
              </Typography>

              <Button disabled={this.state.isValid} type='submit' variant="contained" color="primary" onClick={this.handleSubmit}>
                Відправити
                                <Icon>send</Icon>
              </Button>
            </Toolbar>
          </AppBar>
          <Grid container spacing={16} className={classes.root}>
            <Grid item xs={12} sm={4}>
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="series-number">Серійний номер</InputLabel>
                <Input
                  id="series-number"
                  placeholder="Серійний номер"
                  className={classes.input}
                  onChange={this.handleChange('series')}
                  autoFocus={true}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Technics
                onChange={this.handleChange('techlist')}
                list={this.props.techlist}
                value={this.state.techlist}
                label={'Виберіть тип техніки'}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Technics
                onChange={this.handleChange('model')}
                list={this.props.model_list}
                value={this.state.model}
                label={'Виберіть модель техніки'}
                disable={(this.state.techlist === '') ? true : false}
              />
            </Grid>
            <Autocomplete
              title='Код'
              onChange={this.handleChangeDep}
              action={this.props.actionDep}
              departament={this.props.departament}
            />


            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField id="ticket"
                  multiline
                  label="Опис проблеми"
                  rowsMax="6"
                  onChange={this.handleChange('description')}
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>

      </Dialog>


    )
  }
}

const mapStateToProps = (state) => {
  return {
    user_id: state.auth.access.user_id,
    open: state.modalAction,
    techlist: state.techlist,
    tickets_url: state.tickets,
    departament: state.departament,
    model_list: state.model_list_newticket,
    auth: state.auth
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: (bool) => dispatch(modalAction(bool)),
    actionDep: (val) => dispatch(fetchDataDepartament(val)),
    departamentClear: () => dispatch(departamentClear()),
    actionTicket: (val) => dispatch(addTicket(val)),
    listModelListNewTicket: (id) => dispatch(listModelListNewTicket(id)),
    clearModelListNewTicket: () => dispatch(clearModelListNewTicket()),
    fetchData: (url, bool = false) => {
      dispatch(itemsFetchData(url))
      if (bool === false) {
        dispatch(ticketsUrl(url))
      }
    }
  };

};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NewTicket));




// WEBPACK FOOTER //
// ./src/components/NewTicket/NewTicket.js